<template>
	<div class="myvideo">
		<div class="video_box myvideo-box">
			<video ref="video" disablepictureinpicture="true" controlslist="nodownload noremoteplayback" poster @ended="playEndControler(false)" @timeupdate="playUpdate" @loadedmetadata="setDuration" :src="videourl"></video>
			<div class="my-video-controller">
				<div @click="playControler" class="video_btn">
					<img v-if="playState" src="@img/icon/ui_pause.png" />
					<!-- <img
            v-if="
              video.status === 'play' || video.currentTime === video.duration
            "
            src="@img/icon/ui_play.png"
					/>-->
					<img v-else src="@img/icon/ui_play.png" />
				</div>
				<div class="time">{{ currentTime }}</div>
				<div class="slider_box">
					<div class="myvideo-progress" :style="{
              background:
                'linear-gradient(to right,#ffffff 0,#ffffff ' +
                progress +
                ',#eeeeee ' +
                progress +
                ',#eeeeee 100%)',
            }" ref="progress" @mousedown.stop="progressOnDown" @touchstart.stop="progressOnDown" @mousemove.stop="progressOnMove" @touchmove.stop="progressOnMove" @mouseup.stop="progressOnUp" @mouseout.stop="progressOnUp" @touchend.stop="progressOnUp">
						<span class="circle-progress" :style="{ left: progress }"></span>
					</div>
				</div>
				<div class="time">{{ duration }}</div>
				<div @click="toggleFullscreen" class="full-screen-container">
					<img src="@img/icon/ui_screen.png" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		videourl: String,
		poster: String,
		fullscreen: Boolean,
		autoplay: Boolean
	},
	data() {
		return {
			playState: false,
			currentTime: "00:00",
			progress: "0%",
			progressDrag: false, // 进度条是否被鼠标拖拽
			duration: "00:00",
			fullScreenState: false,
			mutedState: false,
			controlerShow: true,
			controlerShowTimer: "",
			// widthFix: true,
			videoEl: {},
			video: {
				duration: "",
				currentTime: "",
				status: "play",
				fullScreen: false,
				url: ""
			}
		};
	},
	mounted() {
		// console.log("this.videourl,", this.videourl);
		// if (this.autoplay) {
		//   this.playState = true;
		//   this.posterShow = false;
		//   this.$nextTick(() => {
		//     this.controlerShowTimer = setTimeout(() => {
		//       this.controlerShow = false;
		//     }, 5000);
		//   });
		// }
		document.addEventListener("mouseup", this.progressOnUp, false);
		// this.setVideoControl();
	},
	methods: {
		setDuration() {
			// 视频准备完成时执行
			let video = this.$refs.video;
			// if (video.videoWidth > video.videoHeight) {
			//   this.widthFix = true;
			// } else {
			//   this.widthFix = false;
			// }

			// 设置初始音量
			this.voiceProgress = "50%";
			video.volume = 0.5;

			this.duration = this.formatTime(this.$refs.video.duration);
		},
		toggleFullscreen() {
			// 切换全屏
			//this.fullScreenState = !this.fullScreenState;
			if (this.isFullScreen()) {
				this.exitFullscreen();
			} else {
				this.requestFullscreen(document.querySelector(".myvideo-box"));
			}
		},
		isFullScreen() {
			return (
				document.isFullScreen ||
				document.mozIsFullScreen ||
				document.webkitIsFullScreen
			);
		},
		requestFullscreen(ele) {
			// 全屏兼容代码
			if (ele.requestFullscreen) {
				ele.requestFullscreen();
			} else if (ele.webkitRequestFullscreen) {
				ele.webkitRequestFullscreen();
			} else if (ele.mozRequestFullScreen) {
				ele.mozRequestFullScreen();
			} else if (ele.msRequestFullscreen) {
				ele.msRequestFullscreen();
			}
			this.fullScreenState = true;
		},
		// 取消全屏
		exitFullscreen() {
			if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen();
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen();
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen();
			}
			this.fullScreenState = false;
		},
		controlerShowControl(show) {
			// 控制controller的显示隐藏
			if (show) {
				clearTimeout(this.controlerShowTimer);
				this.controlerShowTimer = setTimeout(() => {
					if (this.playState) {
						this.controlerShow = false;
						this.voiceProgressShow = false;
					}
				}, 3000);
			}

			this.controlerShow = show;
		},
		playControler() {
			// 播放按钮点击事件
			console.log("play");
			let video = this.$refs.video;
			if (video.paused || video.ended) {
				video.play();
				this.playState = true;
				this.posterShow = false;
			} else {
				video.pause();
				this.playState = false;
				// clearTimeout(this.controlerShowTimer);
			}
		},
		playEndControler(breakOff) {
			this.currentTime = "00:00";
			this.progress = "0%";
			this.playState = false;
			this.posterShow = true;
			if (breakOff) {
				let video = this.$refs.video;
				video.currentTime = 0;
				if (!(video.paused || video.ended)) {
					video.pause();
				}
				if (this.autoplay) {
					// 如果父组件传入自动播放为true
					this.playState = true;
				}
			}
		},
		stopVideo() {
			this.playState = false;
			this.controlerShow = true;
			let video = this.$refs.video;
			if (!(video.paused || video.ended)) {
				video.pause();
			}
		},
		playUpdate() {
			// 视频播放时进度更新
			if (this.$refs.video) {
				let currentTime = this.$refs.video.currentTime;
				let duration = this.$refs.video.duration;
				let progress = (currentTime / duration) * 100;
				this.currentTime = this.formatTime(currentTime);
				this.progress = progress * 0.996 + "%";
			}
		},
		// 拖拽进度条相关
		progressOnDown(e) {
			this.progressDrag = true;
			this.updateprogress(e.pageX || e.changedTouches[0].pageX);
		},
		progressOnMove(e) {
			if (this.progressDrag) {
				this.updateprogress(e.pageX || e.changedTouches[0].pageX);
			}
		},
		progressOnUp(e) {
			if (this.progressDrag) {
				this.progressDrag = false;
				this.updateprogress(e.pageX || e.changedTouches[0].pageX);
			}
		},
		updateprogress(ePageX) {
			// 更新进度条
			let progressRect = this.$refs.progress.getBoundingClientRect();
			var percent =
				(100 * (ePageX - progressRect.x)) / progressRect.width;
			if (percent > 100) {
				percent = 100;
			}
			if (percent < 0) {
				percent = 0;
			}
			this.progress = percent * 0.996 + "%";
			this.currentTime = this.formatTime(
				(this.$refs.video.duration * percent) / 100
			);
			this.$refs.video.currentTime =
				(this.$refs.video.duration * percent) / 100;
		},
		formatTime(seconds) {
			var minute = Math.floor(seconds / 60);
			if (minute < 10) {
				minute = "0" + minute;
			}

			var second = Math.floor(seconds % 60);
			if (second < 10) {
				second = "0" + second;
			}
			return minute + ":" + second;
		}
	}
};
</script>

<style lang="less" scoped>
@import url("~@styles/common.less");
.myvideo {
	.video_box {
		position: relative;
		width: 1094px;
		height: 615px;
		video {
			width: 100%;
			height: 100%;
			border: 1px solid #707070;
		}
		.my-video-controller {
			height: 72px;
			display: flex;
			align-items: center;
			position: absolute;
			left: 31px;
			right: 31px;
			bottom: 29px;
			.video_btn {
				width: 42px;
				height: 42px;
				margin-right: 32px;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.slider_box {
				flex: 1;
				margin: 0 16px;
				height: 10px;
				background: #ffffff;
				border-radius: 7px;
				.myvideo-progress {
					display: inline-block;
					width: 100%;
					height: 6px;
					line-height: 6px;
					border-radius: 5px;
					vertical-align: super;
					position: relative;
					.circle-progress {
						display: inline-block;
						width: 20px;
						height: 20px;
						border-radius: 50%;
						background: #fff;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
					}
				}
			}
			.time {
				font-size: 30px;
				font-weight: 400;
				line-height: 29px;
				color: #ffffff;
			}
			.full-screen-container {
				width: 42px;
				height: 42px;
				margin-left: 32px;
				img {
					width: 100%;
					height: 100%;
				}
			}
		}
		video::-webkit-media-controls {
			display: none !important;
		}
	}
}
</style>